/**
 * 판매 현황의 화면 말 · 셈(백엔드 V장 "판매 공사" ①, 2026-11-02). 상태 말은 상태 여섯 그대로.
 */
import type { EClosedReason, ESalesOrderFilter, ESalesOrderStatus } from '../../api/client';

/** 상태 → 화면 말(칩 · 409 글과 같은 말) */
export const SALES_ORDER_STATUS_WORD: Record<ESalesOrderStatus, string> = {
  preparing:  '판매 등록',
  confirmed:  '판매 확정',
  ordered:    '출고 요청',
  setup_done: '세팅 완료',
  dispatched: '출고 완료',
  closed:     '취소(일부 출고)',
  cancelled:  '취소',
};

/** 목록 탭 — 진행 중(판매 등록 · 판매 확정 · 출고 요청 · 세팅 완료, 기본) · 상태 다섯 · 전부. 취소(일부 출고)는 뺐다 — 부분 출고가 없어 생길 수 없다(2026-11-03) */
export const SALES_ORDER_FILTER_TABS: readonly { label: string; filter: ESalesOrderFilter }[] = [
  { label: '진행 중',   filter: 'open' },
  { label: '판매 등록', filter: 'preparing' },
  { label: '판매 확정', filter: 'confirmed' },
  { label: '출고 요청', filter: 'ordered' },
  { label: '세팅 완료', filter: 'setup_done' },
  { label: '출고 완료', filter: 'dispatched' },
  { label: '취소',     filter: 'cancelled' },
  { label: '전부',     filter: 'all' },
];

/** 취소 사유 → 화면 말 */
export const CLOSED_REASON_WORD: Record<EClosedReason, string> = {
  customer_cancelled: '고객 취소',
  etc:                '기타',
};

/** 마진율 — 원가가 있는 줄의 판매가(= 원가 + 마진) 대비 %. 원가가 없거나 판매가가 0 이면 null(시안 것 그대로) */
export function marginRateOf(amounts: { cost_amount: number | null; margin_amount: number | null }): number | null {
  if (amounts.cost_amount === null || amounts.margin_amount === null) return null;
  const costedSale = amounts.cost_amount + amounts.margin_amount;
  return costedSale === 0 ? null : (amounts.margin_amount / costedSale) * 100;
}

/** 부족을 둘로 — "로트 미매칭 2 · 구매 필요 1"(0 인 쪽은 뺀다, 백엔드 409 글과 같은 말). 부족이 0 이면 ''(로트 매칭 ④, 2026-11-05) */
export function shortageWordsOf(shortage: number, purchaseNeeded: number): string {
  const unmatched = shortage - purchaseNeeded;
  const parts = [unmatched > 0 ? `로트 미매칭 ${unmatched.toLocaleString('ko-KR')}` : '', purchaseNeeded > 0 ? `구매 필요 ${purchaseNeeded.toLocaleString('ko-KR')}` : ''];
  return parts.filter((part) => part !== '').join(' · ');
}
